/* Something is happening, wherever a person is waiting on a request.
 *
 * Every pending state in this app said its word and showed nothing moving, so
 * a slow count and a stuck one looked the same. The word stays, because a ring
 * on its own says nothing about what is being waited for, and the ring says
 * the wait is live.
 *
 * aria-hidden because the text beside it is what a screen reader should read.
 * Rendering both means "Counting" is announced twice. */
export function Spinner() {
  return <span className="spinner" aria-hidden="true" />;
}

/** A pending state: the ring, then the word. Nothing when it is not pending. */
export function Working({ when, children }: { when: boolean; children: React.ReactNode }) {
  if (!when) return null;
  return (
    <span role="status">
      <Spinner />
      {children}
    </span>
  );
}
